import { Injectable } from '@angular/core';
import { LoginHandler } from 'src/app/services/handlers/login/login.handler';
import { OrganizationHandler } from 'src/app/services/handlers/organization/organization.handler';
import { SiteHandler } from 'src/app/services/handlers/site/site.handler';
import { DeviceHandler } from 'src/app/services/handlers/device/device.handler';
import { ServiceHandler } from 'src/app/services/handlers/service/service.handler';
import { DashboardHandler } from 'src/app/services/handlers/dashboard/dashboard.handler';
import { ProgressHandler } from 'src/app/services/handlers/progress_mode/progress.handler';
import { TimestableHandler } from 'src/app/services/handlers/timestable/timestable.handler';
import { OperatorHandler } from 'src/app/services/handlers/operator/operator.handler';
import { MessageHandler } from 'src/app/services/handlers/message/message.handler';
import { StatisticHandler } from 'src/app/services/handlers/statistic/statistic.handler';
import { PlaceHandler } from 'src/app/services/handlers/place/place.handler';
import { HubHandler } from 'src/app/services/handlers/hub/hub.handler';
import { SlotHandler } from 'src/app/services/handlers/slot/slot.handler';
import { MediaHandler } from 'src/app/services/handlers/media/media.handler';
import { SlotModelHandler } from 'src/app/services/handlers/slot-model/slot-model.handler';
import { ExtraParamsHandler } from 'src/app/services/handlers/extraparams/extraparams.handler';
import { LicenceHandler } from 'src/app/services/handlers/licence/licence.handler';
import { AppRouterHandler } from 'src/app/services/handlers/app_router/app_router.handler';
import { BookNumberingHandler } from 'src/app/services/handlers/bookNumbering/booknumbering';
import { DeviceStatusHandler } from 'src/app/services/handlers/device/device-status.handler';
import { SsoHandler } from 'src/app/services/handlers/sso/sso.handler';

@Injectable({
  providedIn: 'root',
})
export class HandlerManager {
  constructor(
    private _login: LoginHandler,
    private _organization: OrganizationHandler,
    private _site: SiteHandler,
    private _device: DeviceHandler,
    private _service: ServiceHandler,
    private _dashboard: DashboardHandler,
    private _progress: ProgressHandler,
    private _timestable: TimestableHandler,
    private _operator: OperatorHandler,
    private _message: MessageHandler,
    private _place: PlaceHandler,
    private _hub: HubHandler,
    private _slot: SlotHandler,
    private _statistic: StatisticHandler,
    private _licence: LicenceHandler,
    private _slotModel: SlotModelHandler,

    private _media: MediaHandler,
    private _extraParams: ExtraParamsHandler,
    private _appRouter: AppRouterHandler,
    private _bookNumbering: BookNumberingHandler,
    private _deviceStatus: DeviceStatusHandler,
    private _sso: SsoHandler
  ) {}

  login() {
    return this._login;
  }

  organization() {
    return this._organization;
  }

  site() {
    return this._site;
  }

  device() {
    return this._device;
  }

  service() {
    return this._service;
  }

  dashboard() {
    return this._dashboard;
  }

  progress() {
    return this._progress;
  }

  timestable() {
    return this._timestable;
  }

  operator() {
    return this._operator;
  }

  message() {
    return this._message;
  }

  place() {
    return this._place;
  }

  hub() {
    return this._hub;
  }

  slot() {
    return this._slot;
  }

  statistic() {
    return this._statistic;
  }

  media() {
    return this._media;
  }

  slotModel() {
    return this._slotModel;
  }

  extraParams() {
    return this._extraParams;
  }

  licence() {
    return this._licence;
  }
  appRouter() {
    return this._appRouter;
  }

  bookNumbering() {
    return this._bookNumbering;
  }

  deviceStatus() {
    return this._deviceStatus;
  }

  sso() {
    return this._sso;
  }
}
